import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled", "title", "aria-label", "onClick"]
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "border-b border-gray-100 px-6 pb-4 pt-6" }
const _hoisted_4 = { class: "flex items-center gap-2 pr-8 text-lg font-semibold text-gray-900" }
const _hoisted_5 = { class: "pl-7 pr-8 text-xs text-gray-400" }
const _hoisted_6 = { class: "px-6 pt-4" }
const _hoisted_7 = { class: "text-xs font-semibold uppercase tracking-wide text-amber-700" }
const _hoisted_8 = { class: "flex flex-col gap-3 px-6 py-3" }
const _hoisted_9 = { class: "w-5 shrink-0 text-right font-bold text-amber-700" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "border-t border-gray-100 px-6 pb-5 pt-4" }
const _hoisted_13 = { class: "text-xs font-semibold uppercase tracking-wide text-gray-400" }
const _hoisted_14 = {
  key: 0,
  class: "pt-3 text-xs italic text-gray-400"
}
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col gap-3 pt-3"
}
const _hoisted_16 = { class: "w-5 shrink-0 text-right font-bold text-gray-400" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]

import { computed } from 'vue';
import { Modal } from '@makeabledk/vue-ui/components/modal';
import { Medal } from 'lucide-vue-next';
import CloseModalButton from '@/components/common/CloseModalButton.vue';
import { i18n } from '@/plugins/internationalization/i18n';
import type { LeaderboardEntry } from './leaderboard';
import { objectiveValueColourClass } from './objectiveDisplay';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopPerformersModal',
  props: {
    best: {},
    worst: {},
    disabledReason: {},
    windowWeeks: {}
  },
  setup(__props: any) {

const props = __props;

const disabledTooltip = computed<string>(() => {
    if (props.disabledReason === 'minBarns') return i18n.global.t('views.objectives.texts.leaderboardMinBarnsTooltip');
    if (props.disabledReason === 'noData') return i18n.global.t('views.objectives.texts.leaderboardNoDataTooltip');
    return i18n.global.t('views.objectives.texts.leaderboardTitle');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    "close-esc-event": "keydown",
    "close-button": false,
    "modal-class": "w-full max-w-md bg-white m-auto rounded-xl border-0",
    "mask-class": "grid"
  }, {
    toggle: _withCtx((scope) => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["grid h-9 w-9 shrink-0 place-content-center rounded-lg border transition-colors", _ctx.disabledReason ? 'cursor-not-allowed border-gray-200 text-gray-300' : 'border-amber-300 text-amber-600 hover:bg-amber-50']),
        disabled: !!_ctx.disabledReason,
        title: disabledTooltip.value,
        "aria-label": disabledTooltip.value,
        onClick: scope.open
      }, [
        _createVNode(_unref(Medal), {
          class: "h-4 w-4",
          "aria-hidden": "true"
        })
      ], 10, _hoisted_1)
    ]),
    header: _withCtx((scope) => [
      _createVNode(CloseModalButton, {
        onClose: scope.close
      }, null, 8, ["onClose"])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Medal), {
              class: "h-5 w-5 text-amber-600",
              "aria-hidden": "true"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('views.objectives.texts.leaderboardTitle')), 1)
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc('views.objectives.texts.leaderboardWindowSubtitle', _ctx.windowWeeks)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('views.objectives.texts.bestPerformersLabel')), 1)
        ]),
        _createElementVNode("ol", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.best, (entry, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: entry.barnId,
              class: "flex items-center gap-3 text-sm"
            }, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(index + 1), 1),
              _createElementVNode("span", {
                class: "min-w-0 flex-1 truncate font-medium text-gray-800",
                title: entry.barnName
              }, _toDisplayString(entry.barnName), 9, _hoisted_10),
              _createElementVNode("span", {
                class: "max-w-[9rem] truncate text-xs text-gray-400",
                title: entry.farmName
              }, _toDisplayString(entry.farmName), 9, _hoisted_11),
              _createElementVNode("span", {
                class: _normalizeClass(["shrink-0 font-bold", _unref(objectiveValueColourClass)(entry)])
              }, _toDisplayString(_ctx.$n(entry.currentValue, 'decimal')) + "%", 3)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('views.objectives.texts.worstPerformersLabel')), 1),
          (_ctx.worst.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('views.objectives.texts.worstPerformersEmptyNote')), 1))
            : (_openBlock(), _createElementBlock("ol", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.worst, (entry, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: entry.barnId,
                    class: "flex items-center gap-3 text-sm"
                  }, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(index + 1), 1),
                    _createElementVNode("span", {
                      class: "min-w-0 flex-1 truncate font-medium text-gray-800",
                      title: entry.barnName
                    }, _toDisplayString(entry.barnName), 9, _hoisted_17),
                    _createElementVNode("span", {
                      class: "max-w-[9rem] truncate text-xs text-gray-400",
                      title: entry.farmName
                    }, _toDisplayString(entry.farmName), 9, _hoisted_18),
                    _createElementVNode("span", {
                      class: _normalizeClass(["shrink-0 font-bold", _unref(objectiveValueColourClass)(entry)])
                    }, _toDisplayString(_ctx.$n(entry.currentValue, 'decimal')) + "%", 3)
                  ]))
                }), 128))
              ]))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})